import script from "./VitaBeruCreateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaBeruCreateModal.vue?vue&type=script&setup=true&lang=ts"

import "./VitaBeruCreateModal.vue?vue&type=style&index=0&id=5c5e10d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5e10d0"]])

export default __exports__